import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidaciesMinimalQueryKey } from "@/hooks/queries/useGetCandidaciesMinimal";
import { MinimalCandidacy } from "@/types";

/**
 * This hook is used to add a candidacy in the candidacies-minimal query without
 * refetching the entire query.
 */
export const useAddCandidacyInCandidaciesMinimal = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ minimalCandidacy }: { minimalCandidacy: MinimalCandidacy }) => {
    queryClient.setQueriesData(
      { queryKey: candidaciesMinimalQueryKey(currentCompanyId, currentJobId) },
      (cachedData?: MinimalCandidacy[]) => {
        if (!cachedData) return cachedData;
        return [minimalCandidacy, ...cachedData];
      },
    );
  };
};
